import consumer from "./consumer"

let subscription = null

function initRelatorioProdutosSyncChannel() {
  const syncRunContainer = document.getElementById("last-sync-run-container")
  if (!syncRunContainer) {
    if (subscription) {
      subscription.unsubscribe()
      subscription = null
    }
    return
  }
  if (subscription) return
  subscription = consumer.subscriptions.create("RelatorioProdutosChannel", {
    received(data) {
      if (!data || (data.created_at == null && data.updated_at == null)) return
      const container = document.getElementById("last-sync-run-container")
      if (!container) return
      container.innerHTML = renderSyncRun(data)
      const ts = data.updated_at || data.created_at
      container.setAttribute("data-initial-run-id", data.id)
      container.setAttribute("data-initial-run-at", String(Math.floor(new Date(ts).getTime() / 1000)))
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname)
      }
    }
  })
}

document.addEventListener("turbolinks:load", initRelatorioProdutosSyncChannel)
document.addEventListener("DOMContentLoaded", initRelatorioProdutosSyncChannel)

document.addEventListener("turbolinks:before-visit", () => {
  if (subscription) {
    subscription.unsubscribe()
    subscription = null
  }
})

function renderSyncRun(run) {
  const errClass = (run.errors_count || 0) > 0 ? "badge-danger" : "badge-success"
  const dateStr = formatSyncDate(run.updated_at || run.created_at)
  return (
    '<small class="text-light">' +
    "Última sincronização - " + dateStr + ": " +
    '<span class="badge badge-light text-dark ml-1">Total: ' + run.total + "</span>" +
    '<span class="badge badge-success ml-1">Criadas: ' + run.created + "</span>" +
    '<span class="badge badge-secondary ml-1">Ignoradas: ' + run.skipped + "</span>" +
    '<span class="badge ' + errClass + ' ml-1">Erros: ' + run.errors_count + "</span>" +
    "</small>"
  )
}

function formatSyncDate(isoString) {
  const d = new Date(isoString)
  return (
    d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" }) +
    ", " +
    d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
  )
}
